import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Platform, ScrollView, View} from 'react-native';
import {ActivityIndicator, Separator, Text} from 'trpc-react-native-ui';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import {ValidationButton} from '../../components/common';
import SubscriptionDetails from '../../components/subscription/SubscriptionDetails';
import PlanRenewer from '../../components/plan/PlanRenewer';
import {ShortPlan} from '../../components/plan/ShortPlan';
import RtlAwareStyleSheet from '../../lib/rtl-aware-stylesheet';
import FormatService from '../../lib/format';
import formatPeriodicity from '../../lib/TripicaPeriodicityFormatter';
import NextPlanDetails from '../../components/plan/NextPlanDetails';

class YourPlan extends Component {
  _getOfferPrice(styles) {
    const priceKey = 'taxIncludedAmount';

    if (!this.props.subscription?.price?.[priceKey]) {
      return (
        <View style={styles.shortPlanContent}>
          <ActivityIndicator />
        </View>
      );
    }

    return (
      <View style={styles.shortPlanContent}>
        <Text style={styles.planText}>
          {I18n.toPrice(
            FormatService.formatCentsToCurrency(
              this.props.subscription?.price?.[priceKey],
            ),
          )}
        </Text>
        <Text style={styles.strongText}>
          {formatPeriodicity(this.props.subscription?.plan?.periodicity)}
        </Text>
      </View>
    );
  }

  render() {
    const {
      canChangePlan,
      changePlan,
      hasUnauthenticatedPayment,
      isChangingMode = false,
      nextPlan,
      subscription,
    } = this.props;
    const styles = getStyles();

    if (!subscription) return <ActivityIndicator style={styles.container} />;

    const hasNextPlan = !!nextPlan;

    return (
      <View style={styles.container}>
        <View style={styles.tableContent}>
          <ShortPlan subscription={subscription} />
          <Separator direction="vertical" />
          {this._getOfferPrice(styles)}
        </View>
        <ScrollView style={styles.scrollContainer}>
          <View style={styles.detailedContainer}>
            <SubscriptionDetails
              options={subscription.options}
              planCharacteristics={subscription.plan?.characteristics}
            />
          </View>
          {hasNextPlan ? <NextPlanDetails /> : null}
          <View style={styles.frameContent}>
            <PlanRenewer
              subscription={subscription}
              isChangingMode={isChangingMode}
              style={styles.renewalContent}
              disabled={hasNextPlan}
            />
          </View>
        </ScrollView>
        <ValidationButton
          testID="yourPlan-changePlan-button"
          text={I18n.t('changePlan')}
          onPress={() => changePlan(subscription)}
          disabled={hasUnauthenticatedPayment || !canChangePlan || hasNextPlan}
        />
      </View>
    );
  }
}

function getStyles() {
  return RtlAwareStyleSheet.create({
    container: {
      backgroundColor: theme.backgroundColor,
      flex: 1,
      marginBottom: Platform.OS === 'ios' ? 20 : 0,
    },
    detailedContainer: {
      paddingBottom: 10,
      paddingLeft: 25,
      paddingRight: 25,
      paddingTop: 10,
    },
    scrollContainer: {
      flex: 1,
    },
    endContent: {
      flex: 1,
      justifyContent: 'center',
    },
    frameContent: {
      borderTopColor: '#ddd',
      borderTopWidth: 1,
      flexDirection: 'row',
    },
    planText: {
      color: theme.secondaryColor,
      fontSize: 20,
      fontWeight: '600',
    },
    renewalContent: {
      flex: 1,
    },
    shortPlanContent: {
      alignItems: 'center',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
    },
    strongText: {
      color: theme.secondaryColor,
      fontSize: 14,
      textAlign: 'center',
    },
    tableContent: {
      borderBottomColor: '#ddd',
      borderBottomWidth: 1,
      flex: 0,
      flexDirection: 'row',
      marginLeft: 0,
      marginRight: 0,
      padding: 10,
    },
  });
}

YourPlan.propTypes = {
  canChangePlan: PropTypes.bool,
  changePlan: PropTypes.func.isRequired,
  folded: PropTypes.bool,
  hasUnauthenticatedPayment: PropTypes.bool,
  isChangingMode: PropTypes.bool,
  subscription: PropTypes.object,
  nextPlan: PropTypes.object,
  switchValue: PropTypes.bool,
};

export default YourPlan;
